module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-144x144-352125e8cae950fdafb29e95cdaf7e24.png";